/* eslint-disable no-param-reassign, no-else-return */
export default {
  setOnetJobGroupSelected(state, jobGroup) {
    state.onetJobGroupSelected = jobGroup;
  },
  setCurrencySelected(state, currency) {
    state.currencySelected = currency;
  },
  setSectorSelected(state, sector) {
    state.sectorSelected = sector;
  },
  setSectors(state, v) {
    state.sectors = v;
  },
  setCountries(state, v) {
    state.countries = v;
  },
  setCurrencies(state, v) {
    state.currencies = v;
  },
  setOnetJobGroups(state, v) {
    v.sort((a, b) => {
      if (a.jobGroup === 'All' && b.jobGroup !== 'All') {
        return -1;
      } else if (a.jobGroup !== 'All' && b.jobGroup === 'All') {
        return 1;
      }
      if (a.jobGroup === 'Executive Director' && b.jobGroup !== 'Executive Director') {
        return -1;
      } else if (a.jobGroup !== 'Executive Director' && b.jobGroup === 'Executive Director') {
        return 1;
      }
      if (a.jobGroup === 'Non-Executive Director' && b.jobGroup !== 'Executive Director') {
        return -1;
      } else if (a.jobGroup !== 'Non-Executive Director' && b.jobGroup === 'Executive Director') {
        return 1;
      }
      if (a.jobGroup === 'Independent Non-Executive Director' && b.jobGroup !== 'Executive Director') {
        return -1;
      } else if (a.jobGroup !== 'Independent Non-Executive Director' && b.jobGroup === 'Executive Director') {
        return 1;
      }
      return (a.jobGroup > b.jobGroup) ? 1 : -1;
    });
    state.onetJobGroups = v;
  },
  setCountriesSelected(state, countries) {
    state.countriesSelected = countries;
  },
  setMinMaxJobClasses(state, mm) {
    state.minMaxJobClasses = mm;
  },
  setMinMaxLoading(state, val) {
    state.minMaxLoading = val;
  },
  setAccessRights(state, rights) {
    state.accessRights = rights;
  },
};
